const { ENV_TITLE } = process.env

exports.envPreffix = () => {
  return ENV_TITLE ? ENV_TITLE : ''
}

exports.FuncSetInternal = (func, time) => setInterval(func, time * 1000)

exports.isStrongPassword = val => {
  const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')
  return strongRegex.test(val)
}
